
const standardtask = {
    service: {
        required: "Service is required",
    },
    workgroup: {
        required: "Work Group is required",
    },
    taskcode: {
        required: "Task Code is required",
        exist: "Task Code already exists for Work Group",
        inuse: "Task Code is in use.It cannot be deleted",
    },
    taskdescription: {
        required: "Task Description is required",
    },
    effectivefrom: {
        required: "Effective From is required",
    },
}

const calibration = {
    service: {
        required: "Service is required",
    },
    licenseregno: {
        required: "Calibration No. is Required",
    },
    licensecategory: {
        required: "Calibration Category is required",
    },
    licensetypecode: {
        required: "Calibration Type Code  is required",
    },
    licenseclassgrade: {
        required: " Class/Grade is required",
    },
    expirydate: {
        required: "Expiry Date is required",
    },
    hospital: {
        required: "Hospital Name is required",
    }

}

const License = {
    service: {
        required: "Service is required",
    },
    licenseregno: {
        required: "License / Registration No. is Required",
    },
    licensecategory: {
        required: "License Category is required",
    },
    licensetypecode: {
        required: "License Type Code  is required",
    },
    licenseclassgrade: {
        required: " Class / Grade is required",
    },
    expirydate: {
        required: "Expiry Date is required",
    },
    hospitalname: {
        required: "Hospital Name is required",
    }
}

const assetCondition = {
    date: {
        required: "Date is required"
    },
    equipmentcondition: {
        required: "Equipment Condition is required",
        exist: "Equipment Condition Should not be the Same as Previous entered one"
    }
}
const validations = {
    textfieldCode: "Invalid Input.'/'and'-' Only these two special characters are allowed.",
    textfield: 'Invalid Input.{a-zA-Z0-9.,-_!@#$%&*()}- Only these characters are allowed.',
    email: 'Invalid Input. Please Enter Valid Email Address',
    phoneNumber: 'Invalid Input. Please Enter Valid Phone Number',
    price: 'Invalid Input. Please Enter Valid price',
    default: 'Something went wrong. Please try again later.',
    clickIcon: "Please click '+' icon to add values",
}

const vendor = {
    vendorname: {
        required: "Vendor Name is required",
    },
    vendorcode: {
        required: "Vendor Code is required",
    },
    status: {
        required: "Status is required",
    },
    effectiveDate: {
        required: "Effective Date is required",
    },
    preference: {
        required: "Preference is required",
    },
    companytype: {
        required: "Type of Company is required",
    },
    category: {
        required: "Category is required",
    },
    group: {
        required: "Group is required",
    },
    service: {
        required: "Service is Required. Please Select atleast one from the followings",
    },
    class: {
        required: "Class is Required. Please Select atleast one from the followings"
    },
    address1: {
        required: "Address1 is required"
    },
    state: {
        required: "State is required"
    },
    country: {
        required: "Country is required"
    },
    postcode: {
        required: "Postcode is required"
    }
}

const staff = {
    employeeid: {
        required: "Staff ID is required",
    },
    employeename: {
        required: "Staff Name is required",
    },
    employeetype: {
        required: "Staff Type is required",
    },
    service: {
        required: "Service is Required. Please Select atleast one from the followings(*).",
    },
    designation: {
        required: "Designation is required",
    },
    workgroup: {
        required: "Work Group is required",
    },
    effectivefrom: {
        required: "Effective From is required",
    },
    skilllevel: {
        required: "Skill Level is required",
    },
    baselocationcode:{
        required:"Base Location - Code is required"
    },
    roleName:{
        required:"Role Name is required"
    },
}

const ppmCheckList = {
    service: {
        required: "Service is required",
    },
    typeCode: {
        required: "Asset Type Code is required",
    },
    taskCode: {
        required: "Task Code is required",
    },
    status: {
        required: "Status is required",
    },
   
}

const contractresgister = {
    contractno: {
        required: "Contract No. is required",
        exist: "Contract No already exists for this Contract",
    },
    service: {
        required: "Service is required",
    },
    vendorname: {
        required: "Vendor Name is required",
    },
    // vendorcode: {
    //     required: "Vendor Code is required",
    // },
}

export {
    standardtask,
    validations,
    calibration,
    License,
    assetCondition,
    vendor,
    staff,
    contractresgister,
    ppmCheckList
}